import BalanceCollect from './index';

export default { path: '/home/audit/partner/balance/collect', component: BalanceCollect };